import React, { useState } from 'react';

const RegistrationModal = ({ isOpen, onClose }) => {
  // Added local states for status handling
  const [status, setStatus] = useState('idle'); // 'idle', 'loading', 'success', 'error'
  const [statusMsg, setStatusMsg] = useState('');

  if (!isOpen) return null;

  // HELPER: Only allow numbers in the phone field
  const handlePhoneInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    
    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    try {
      const response = await fetch('/sendmail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      
      if (result.status === 'success') {
        setStatus('success');
        setStatusMsg("Registration Successful! We will call you shortly.");
        // Auto-close after 3 seconds
        setTimeout(() => {
          onClose();
          setStatus('idle');
          setStatusMsg('');
        }, 3000);
      } else {
        throw new Error("Server error");
      }
    } catch (error) {
      setStatus('error');
      setStatusMsg("Something went wrong. Please try calling 9700213084.");
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content ice-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>&times;</button>
        
        <div className="modal-header">
          <span className="hero-badge">Summer 2026</span>
          <h3>Summer Camp Registration</h3>
          <p>Join the legacy of 24,000+ successful students.</p>
        </div>

        {/* Status Messages displayed above the form */}
        {status === 'success' && <div className="status-msg success">{statusMsg}</div>}
        {status === 'error' && <div className="status-msg error">{statusMsg}</div>}

        {/* Hide form only on success to keep the 'Ice' look consistent */}
        {status !== 'success' && (
          <form className="modal-registration-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Student Name</label>
              <input 
                type="text" 
                name="student_name" 
                placeholder="Enter name" 
                required 
                disabled={status === 'loading'}
              />
            </div>

            <div className="form-group">
              <label>Parent's Mobile Number</label>
              <input 
                type="tel" 
                name="parent_phone" 
                placeholder="Enter 10-digit number" 
                required 
                maxLength="10"
                onInput={handlePhoneInput}
                disabled={status === 'loading'}
              />
            </div>

            <div className="form-group">
              <label>Select Summer Track</label>
              <select name="selected_program" required disabled={status === 'loading'}>
                <option value="">-- Choose a Program --</option>
                <option value="Advanced Foundation">Advanced Foundation (Class 1-10)</option>
                <option value="Basic Foundation">Basic Foundation (Class 1-10)</option>
                <option value="Intermediate Bridge">Intermediate IIT-Foundation (10th Passed)</option>
                <option value="10th Class Bridge">10th Class Bridge Course (9th Completed)</option>
                <option value="Skill Oriented">Skill Oriented Courses (Coding/English)</option>
              </select>
            </div>

            <input type="hidden" name="source" value="timed_or_manual_popup" />

            <button type="submit" className="btn-submit-modal" disabled={status === 'loading'}>
              {status === 'loading' ? 'Processing...' : 'Complete Registration'}
            </button>
            
            <p className="form-note">Starts from 24th April, 2026</p>
          </form>
        )}
      </div>
    </div>
  );
};

export default RegistrationModal;